import { render } from "./GiftsInboxPage.vue?vue&type=template&id=08fed47c&scoped=true"
import script from "./GiftsInboxPage.vue?vue&type=script&lang=js"
export * from "./GiftsInboxPage.vue?vue&type=script&lang=js"

import "./GiftsInboxPage.vue?vue&type=style&index=0&id=08fed47c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08fed47c"]])

export default __exports__